import { buildBreadcrumbNavigationConfig } from "../shared/helpers/buildBreadcrumbNavigationConfig";
import { LearningContainer } from "./pages/learningContainer/learningContainer";
import { LearningDetails } from "./pages/learningDetails/LearningDetails";
import { LearningRedirect } from "./pages/LearningRedirect";

const participantLearningContentPath = "/learning";
const participantCollectibleContentPath = "/collectibles";
const participantRewardsContentPath = "/rewards";
const participantMyLearningContentPath = "/learning/myContent";
const participantLearningDetailsPath = "/learning/:id";
const participantLearningRedirectPath = "/learningRedirect/:id";

const participantLearningContentPageNav = buildBreadcrumbNavigationConfig(
  "Learning",
  participantLearningContentPath
);
const participantCollectiblesContentPageNav = buildBreadcrumbNavigationConfig(
  "Collectibles",
  participantCollectibleContentPath
);
const participantRewardsContentPageNav = buildBreadcrumbNavigationConfig(
  "Rewards",
  participantRewardsContentPath
);
const participantLearningContentDetailsPageNav =
  buildBreadcrumbNavigationConfig("Learning", participantLearningDetailsPath);

const participantMyLearningContentPageNav = buildBreadcrumbNavigationConfig(
  "My Content",
  participantMyLearningContentPath
);

export const routes = [
  {
    path: participantLearningContentPath,
    Component: LearningContainer,
    navigation: [participantLearningContentPageNav],
    exact: true,
    isPrivate: true,
  },
  {
    path: participantCollectibleContentPath,
    Component: LearningContainer,
    navigation: [participantCollectiblesContentPageNav],
    exact: true,
    isPrivate: true,
  },
  {
    path: participantRewardsContentPath,
    Component: LearningContainer,
    navigation: [participantRewardsContentPageNav],
    exact: true,
    isPrivate: true,
  },
  {
    path: participantLearningDetailsPath,
    Component: LearningDetails,
    navigation: [participantLearningContentDetailsPageNav],
    exact: true,
    isPrivate: true,
  },
  {
    path: participantMyLearningContentPath,
    Component: LearningContainer,
    navigation: [participantMyLearningContentPageNav],
    exact: true,
    isPrivate: true,
  },
  {
    path: participantLearningRedirectPath,
    Component: LearningRedirect,
    exact: true,
    isPrivate: true,
  },
];
